/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import './src/styles/global.css';
import React from 'react';
import ModeProvider from '@context/ModeProvider';

// Gatsby API: wrapRootElement allows you to wrap the entire app in a component

export const wrapRootElement = ({ element }) => (
  <ModeProvider>{element}</ModeProvider>
);

